// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-8b45d41e]{margin:1rem 0}", "",{"version":3,"sources":["webpack://./resources/js/components/campaign/conversational/field/FieldSelect.vue"],"names":[],"mappings":"AAAA,uBAAM,aAAa","sourcesContent":["label{margin:1rem 0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
